import { render, staticRenderFns } from "./DxTableProdcutos.vue?vue&type=template&id=005b66fe&scoped=true&"
import script from "./DxTableProdcutos.vue?vue&type=script&lang=ts&"
export * from "./DxTableProdcutos.vue?vue&type=script&lang=ts&"
import style0 from "./DxTableProdcutos.vue?vue&type=style&index=0&id=005b66fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005b66fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
